<template>
  <div>
    <a @click="showDetails"
       class="pointer"
       v-if="val">
    {{ formatNumber(val, true) }}
    </a>
    <span v-else>-</span>
  </div>
</template>

<script setup>
import {formatNumber} from "@/extensions/filters/filters"
import {computed, getCurrentInstance, onMounted} from "vue"
import {useStore} from "vuex"

const props = defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  }
})

const store = useStore()

let bvModal = null

onMounted(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
})

const val = computed(() => {
  return props.object[props.field.id] || 0
})

const details = computed(() => {
  return props.object[`${props.field.id}_details`] || []
})

const showDetails = () => {
  store.commit('setLineItemDetails', details.value)
  bvModal.show('report-number-details-modal')
}
</script>
